import { useEffect, useMemo, useState } from "react";

import createContextFactory from "@Utils/factory";

import { useStateGrid } from "./hooks/state";

function useGridFactory({ store }) {
  const [definitions, setDefinitions] = useState(null)
  const [columns, setColumns] = useState(null)
  const [filters, setFilters] = useState(null)
  const [events, setEvents] = useState(null)
  const [rowsSelected, setRowsSelected] = useState([])

  const state = useStateGrid(definitions || {})
  const { options, term, autoRefresh } = state
  const { collections: { useLoad, list: handleRefresh } } = store
  const { defaultParams } = definitions || {}
  useLoad(useMemo(() => ({ options, term, autoRefresh, ...defaultParams }), [options, term, autoRefresh, defaultParams]))

  return useMemo(() => ({
    state, store,
    definitions, setDefinitions,
    columns, setColumns,
    filters, setFilters,
    events, setEvents,
    rowsSelected, setRowsSelected,
    handleRefresh,
  }), [columns, definitions, events, filters, state, store, rowsSelected, handleRefresh])
}

export function useBuildGrid({ definitions, columns, filters, events }) {
  const { setDefinitions, setColumns, setFilters, setEvents } = useGrid()

  useEffect(() => {
    setDefinitions(definitions)
  }, [definitions, setDefinitions])

  useEffect(() => {
    setColumns(columns)
  }, [columns, setColumns])

  useEffect(() => {
    setFilters(filters)
  }, [filters, setFilters])

  useEffect(() => {
    setEvents(events)
  }, [events, setEvents])
}

const {
  Provider: GridProvider,
  useContext: useGrid,
} = createContextFactory(useGridFactory)

export {
  useGrid,
  GridProvider,
}
